import React from 'react';
import type { components } from '../../../../types/learnerApi';

type Config = components['schemas']['SanitizedTupleMatchingConfig'];

export interface TupleMatchingAnswer {
  matches: Record<string, string>;
}

export interface TupleMatchingViewProps {
  item: { id: string; points?: number; config: Config };
  mode: 'learner' | 'preview';
  value?: TupleMatchingAnswer;
  onChange?: (value: TupleMatchingAnswer) => void;
  disabled?: boolean;
}

const TupleMatchingView: React.FC<TupleMatchingViewProps> = ({
  item,
  mode,
  value,
  onChange,
  disabled,
}) => {
  const matches = value?.matches ?? {};

  const handleSelect = (leftId: string, rightId: string) => {
    if (disabled || mode === 'preview') return;
    const updated = { ...matches, [leftId]: rightId };
    onChange?.({ matches: updated });
  };

  return (
    <div className="space-y-4">
      <p className="font-medium text-text-primary">{item.config.question}</p>
      <div className="space-y-3">
        {(item.config.left ?? []).map((leftEntry) => {
          const selectedRightId = matches[leftEntry.id];
          return (
            <div key={leftEntry.id} className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
              <div className="flex-1 px-3 py-2 rounded-lg bg-surface-secondary border border-border text-sm text-text-primary min-w-0">
                {leftEntry.text}
              </div>
              <span className="text-text-tertiary hidden sm:block">→</span>
              <select
                value={selectedRightId ?? ''}
                onChange={(e) => handleSelect(leftEntry.id, e.target.value)}
                disabled={disabled}
                style={{ colorScheme: 'light dark' }}
                className="flex-1 px-3 py-2 rounded-lg border border-border bg-surface-secondary text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-60"
                aria-label={`Match for: ${leftEntry.text}`}
              >
                <option value="" className="bg-surface-secondary text-text-primary">— select —</option>
                {(item.config.right ?? []).map((rightEntry) => (
                  <option key={rightEntry.id} value={rightEntry.id} className="bg-surface-secondary text-text-primary">
                    {rightEntry.text}
                  </option>
                ))}
              </select>
            </div>
          );
        })}
      </div>
      {item.points != null && (
        <p className="text-xs text-text-tertiary">{item.points} pt{item.points !== 1 ? 's' : ''}</p>
      )}
    </div>
  );
};

export default TupleMatchingView;
